<template>
    <div v-if="clip">
        <span @click="clip.advancedControls = !clip.advancedControls" v-if="$route.name !='PersonReview'">
            <input type="checkbox" :value="clip.advancedControls">
            <label>Contrôles avancés</label>
        </span>
        <div style="margin-top:42px" v-if="clip.advancedControls">
            <label>Ajustement début/fin</label>
            <vue-slider v-if="clip.duration" style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.001" :min="0" :max="clip.duration" v-model="clip.times" :formatter="prepareTimeString"></vue-slider>
<!--             <label>Volume</label>
            <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.005" :min="0" :max="2" v-model="clip.ws.backend.gainNode.gain.value" orient="vertical"></vue-slider> -->
        <!--                         <label>Attaque</label>
            <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.01" :min="0" :max="10" v-model="clip.attack"></vue-slider>
            <label>Extinction</label>
            <vue-slider style="margin-left:42px;margin-right:42px;margn-bottom:5px;margin-top:30px" :interval="0.01" :min="0" :max="10" v-model="clip.release"></vue-slider>-->
<!--             <label>Filtre passe-haut</label>
            <div style="margin-top:5px">
                <label style="margin-left:30px">Fréquence</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="1" :min="10" :max="22050" v-model="clip.ws.backend.filters[0].frequency.value"></vue-slider> 
                <label style="margin-left:30px">Peak</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.0001" :min="0.0001" :max="10" v-model="clip.ws.backend.filters[0].Q.value"></vue-slider>            
            </div>            -->
<!--             <label>Filtre passe-bas</label>
            <div style="margin-top:5px">
                <label style="margin-left:30px">Fréquence</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="1" :min="10" :max="22050" v-model="clip.ws.backend.filters[1].frequency.value"></vue-slider> 
                <label style="margin-left:30px">Peak</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.0001" :min="0.0001" :max="10" v-model="clip.ws.backend.filters[1].Q.value"></vue-slider>                       
            </div> -->
        <!--                         <label>Filtre passe-bande</label>
            <div style="margin-top:5px">
                <label style="margin-left:30px">Fréquence</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="1" :min="10" :max="22050" v-model="clip.ws.backend.filters[2].frequency.value"></vue-slider> 
                <label style="margin-left:30px">Peak</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.0001" :min="0.0001" :max="10" v-model="clip.ws.backend.filters[2].Q.value"></vue-slider>                       
            </div> -->
<!--             <label>Compresseur</label>
            <div style="margin-top:5px">
                <label style="margin-left:30px">Threshold</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.5" :min="-100" :max="0" v-model="clip.ws.backend.filters[1].threshold.value"></vue-slider> 
                <label style="margin-left:30px">Knee</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.5" :min="0" :max="40" v-model="clip.ws.backend.filters[1].knee.value"></vue-slider>
                <label style="margin-left:30px">Ratio</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.5" :min="1" :max="20" v-model="clip.ws.backend.filters[1].ratio.value"></vue-slider> 
                <label style="margin-left:30px">Attack</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.001" :min="0" :max="1" v-model="clip.ws.backend.filters[1].attack.value"></vue-slider>
                <label style="margin-left:30px">Release</label>
                <vue-slider style="margin-left:42px;margin-right:42px;margin-bottom:5px;margin-top:30px" :interval="0.001" :min="0" :max="1" v-model="clip.ws.backend.filters[1].release.value"></vue-slider> 
            </div> -->
<!--             <label>Equaliseur</label>
            <div id="equalizer" style="text-align:center;margin-top: 10px" v-if="clip.ws && clip.ws.backend.filters.length">
                <input type="range" :min="-40" :max="40" v-model="eqMaster" title="Master" style="display:inline-block;-webkit-appearance: slider-vertical;width: 70px;height: 150px;">
                <input v-for="(band, bandIndex) in eq" type="range" :min="-40" :max="40" v-model="clip.ws.backend.filters[bandIndex + 2].gain.value" :title="band.f" style="display:inline-block;-webkit-appearance: slider-vertical;width: 70px;height: 150px;">
                <br>
                <label style="width:70px">Master</label>
                <label v-for="band in eq" style="width:70px">{{ band.f + ' Hz'}}</label>
            </div> -->
        </div>
    </div>
</template>

<script>
    import vueSlider from 'vue-slider-component';

    export default {
        computed: {
            eqMaster: {
                get: function() {
                    return this.clip.eqMaster;
                },
                set: function(newValue) {
                    let limit = this.clip.ws.backend.filters.length - 3;

                    this.clip.eqMaster = newValue;
                    for (let i = 0; i < limit; i++)   {
                        this.clip.ws.backend.filters[i + 3].gain.value = newValue;
                        this.$set(this.clip.ws.backend.filters, i + 3, this.clip.ws.backend.filters[i + 3])
                    }
                }
            }
        },
        components: {
            vueSlider
        },
    	methods: {
            prepareTimeString(seconds) {
                let hours = Math.trunc(seconds / 3600);
                let minutes = Math.trunc((seconds % 3600) / 60)
                let nseconds = Math.trunc(seconds % 60);
                let thousandths = Math.trunc((seconds % 1) * 1000);
                return ((hours + '').length == 1 ? '0' + hours : hours) + ':' + ((minutes + '').length == 1 ? '0' + minutes : minutes) + ':' + ((nseconds + '').length == 1 ? '0' + nseconds : nseconds) + '.' + thousandths;
            }
    	},
    	props: ['clip', 'eq']
	};
</script>
